import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { map } from 'rxjs/operators';

export interface ITenant {
  id: string;
  name: string;
  domain: string;
}

@Injectable({
  providedIn: 'root'
})
export class AzureResourceManagerService {

  /**
   * The permission needed are 
   * https://management.azure.com/user_impersonation
   * 
   * Helpful links
   * https://docs.microsoft.com/en-us/rest/api/resources/tenants/list?tabs=HTTP
   */

  private AZURE_MGMT_API_URL = 'https://management.azure.com/';
  private API_VERSION = '?api-version=2020-01-01';

  constructor(private http: HttpClient) {

  }

  public getTenants(): Observable<ITenant[]> {
    return this.http.get<{ value: { tenantId: string, displayName: string, defaultDomain: string }[] }>(`${this.AZURE_MGMT_API_URL}tenants${this.API_VERSION}`)
      .pipe(
        map((result) => {
          const value = result.value;
          value.sort((a, b) => a.displayName.localeCompare(b.displayName));
          const tenants: ITenant[] = [];
          for (const v of value) {
            tenants.push(
              {
                id: v.tenantId,
                name: v.displayName,
                domain: v.defaultDomain
              }
            );
          }
          return tenants;
        })
      );
  }
}


